import { FaDownload } from "react-icons/fa";
import resumeData from "../../data/resumeData";

const ResumeSection = ({ darkMode = false }) => (
  <section
    id="qualifications"
    className={`py-14 sm:py-16 ${darkMode ? "bg-stone-900 text-white" : "bg-white text-stone-950"}`}
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
      <div className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.24em] text-teal-800 dark:text-teal-300">
            Education & certifications
          </p>
          <h2 className="mt-3 text-3xl font-black leading-tight sm:text-4xl">
            Background and credentials.
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-stone-700 dark:text-stone-300">
            {resumeData.education.degree} · {resumeData.education.institution} ·{" "}
            {resumeData.education.period} · {resumeData.education.result}
          </p>
          <p className="mt-2 text-sm font-semibold text-stone-600 dark:text-stone-400">
            {resumeData.languages}
          </p>
        </div>
        <a
          href={resumeData.resumePdf}
          download="Denzil_Martin_Resume.pdf"
          className="inline-flex items-center gap-3 rounded-full bg-teal-700 px-5 py-3 text-sm font-bold text-white transition hover:bg-teal-800"
        >
          <FaDownload /> Download resume
        </a>
      </div>

      <div className="mt-8 grid gap-3 sm:grid-cols-3">
        {resumeData.certifications.map((cert) => (
          <article
            key={cert.code}
            className={`rounded-xl border-l-2 border-teal-700/40 px-4 py-3 ${
              darkMode ? "bg-stone-800/40" : "bg-[#f4f1ea]"
            }`}
          >
            <p className="text-xs font-bold text-teal-800 dark:text-teal-300">
              {cert.code} · {cert.year}
            </p>
            <h3 className="mt-1 text-sm font-semibold">{cert.name}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ResumeSection;
